import React from 'react';
import { Pill } from '../../index';

/**
 * StatusBadge — uniform lifecycle-status rendering across the
 * compliance domain. Different surfaces use slightly different
 * vocabularies (attestation OPEN/SUBMITTED/APPROVED vs remediation
 * OPEN/IN_PROGRESS/RESOLVED vs certificate ACTIVE/EXPIRED/REVOKED
 * vs report READY/GENERATING/FAILED), but they all share the same
 * traffic-light visual semantics — actionable = warning,
 * resolved = success, broken = danger, in-flight = info.
 *
 * Phase B / G321.
 */
const STATUS_MAP = {
  // Attestations
  OPEN:        { tone: 'warning', dot: true },
  SUBMITTED:   { tone: 'cyan',    dot: true },
  APPROVED:    { tone: 'success', dot: true },
  REJECTED:    { tone: 'danger',  dot: true },
  // Remediation
  IN_PROGRESS: { tone: 'cyan',    dot: true },
  RESOLVED:    { tone: 'success', dot: true },
  VERIFIED:    { tone: 'success', dot: true },
  ESCALATED:   { tone: 'danger',  dot: true },
  // Certificates
  ACTIVE:      { tone: 'success', dot: true },
  EXPIRED:     { tone: 'warning', dot: true },
  REVOKED:     { tone: 'danger',  dot: true },
  PENDING:     { tone: 'warning', dot: true },
  // Reports
  READY:       { tone: 'success', dot: true },
  GENERATING:  { tone: 'cyan',    dot: true },
  FAILED:      { tone: 'danger',  dot: true },
  // Regulatory changes
  ACKNOWLEDGED:{ tone: 'cyan',    dot: true },
  MITIGATED:   { tone: 'success', dot: true },
  // Control mapping
  AUTO_APPROVED:{ tone: 'success', dot: true },
};

export function StatusBadge({ status, size = 'sm' }) {
  const key = String(status || '').toUpperCase();
  const cfg = STATUS_MAP[key] || { tone: 'muted', dot: false };
  return (
    <Pill tone={cfg.tone} size={size} dot={cfg.dot}>
      {key.replace(/_/g, ' ')}
    </Pill>
  );
}

export default StatusBadge;
